module.exports = __webpack_public_path__ + "img/lg_ring_g_skip_null_0.00c758a8.png";